import { useQuery } from "src/Hooks/useReactQuery";
import { getTestSequenceTags } from "src/services/test-packages";

const useGetTestSequenceTags = (testPackageId, options = {}) => {
  const { enabled = true, onSuccess, setTags, reset, getRandomColor, showAlert, t, refetchOnWindowFocus = true, ...restOptions } = options;

  const { data, isLoading, isError, error, refetch, isFetching } = useQuery(
    ["testSequenceTags", testPackageId],
    () => getTestSequenceTags(testPackageId),
    {
      enabled: enabled && !!testPackageId,
      refetchOnWindowFocus: refetchOnWindowFocus,
      onSuccess: (data) => {
        let initTags = [];
        if (data?.data?.items && getRandomColor) {
          initTags = data.data.items.map((tag, index) => ({
            ...tag,
            color: tag.color || getRandomColor(),
          }));
        }
        if (setTags) {
          setTags(initTags);
        }
        if (reset) {
          reset(initTags);
        }
        if (onSuccess) {
          onSuccess(data);
        }
      },
      ...restOptions,
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
  };
};

export default useGetTestSequenceTags;
